import { useMemo } from 'react'
import useMediaSelectionActions from '@/actions/useMediaSelectionActions'
import { useUserContext } from '@/UserContext'
import { queryCurrentMediaSelectionWithFallback } from '@/Logic'
import { SimpleSelect } from '@/UIComponents2/Select/SimpleSelect'
import CameraIcon from '@/CustomIcons/CameraIcon'

type CameraSelectProps = {
    className?: string
    triggerClassName?: string
}
export function CameraSelect(props: CameraSelectProps) {
    const [userState] = useUserContext()
    const { setMediaSelection } = useMediaSelectionActions()

    const videoOpts = useMemo(
        () => userState.mediaSources.video.map((input) => ({ value: input.deviceId, label: input.label })),
        [userState.mediaSources.video]
    )
    const selectedVideoVal = useMemo(
        () => queryCurrentMediaSelectionWithFallback(userState.mediaSelection, userState.mediaSources, 'video'),
        [userState.mediaSelection, userState.mediaSources]
    )

    const handleVideoSelect = (deviceId: string | undefined) => {
        if (deviceId !== undefined) {
            setMediaSelection({ video: deviceId })
        } else {
            setMediaSelection({ video: '_none' })
        }
    }

    return (
        <SimpleSelect
            items={videoOpts}
            value={selectedVideoVal}
            className={props.className}
            triggerClassName={props.triggerClassName}
            leftElement={<CameraIcon style={{ fontSize: '1.3rem' }} />}
            onChange={(val) => handleVideoSelect(val ?? undefined)}
            widthMatching
        />
    )
}
